<template>
  <div class="body-wrapper">
    <div class="body-wrapper table-poll">
      <div class="table-wrapper">
        <spinner
          class="spinner"
          line-fg-color="#00796b"
          :size="100"
          :line-size="6"
          v-if="loading"
        ></spinner>
        <div v-show="!loading">
          <button
            v-if="$router.history.current.name == 'communityPosts'"
            @click="showModal('ModalContentPost')"
            class="btn"
          >
            Nova objava
          </button>
          <data-table
            :columns="tableColumns"
            :tableData="tableData"
            :options="tableOptions"
            :slotNameActionPost="'action'"
            :slotNamePostPin="'pin'"
          ></data-table>
          <!-- :slotDatePost="'time'" -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '@/components/community/Table';
import { mapMutations, mapState, mapActions } from 'vuex';

export default {
  components: {
    DataTable
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('modal', ['modalVisible']),
    ...mapState('table', ['tableColumns', 'tableData', 'tableOptions'])
  },
  created() {
    // alerts Community view that card is opened so
    // proper badge is loaded
    this.cardOpened();
    //loading data to table
    this.getPostsByCommunity(this.$store.getters.getActiveCommunity.id);

    /*
     * setting badge of active view (polls)
     * */
    this.setTableBadge('far fa-newspaper');

    //setting up table options and table column names

    this.initTable('postsTable');
  },
  destroyed() {
    //unsetting badge when view is closed
    //this.unsetTableData();
    this.setTableBadge('');
  },
  methods: {
    ...mapActions('table', ['initTable', 'getPostsByCommunity']),
    ...mapMutations(['cardOpened']),
    ...mapMutations('modal', ['showModal']),
    ...mapMutations('table', ['setTableBadge', 'unsetTableData'])
  }
};
</script>
<style lang="scss" scoped>
.body-wrapper {
  display: block;
  padding: 10px;
}

.table-wrapper {
  position: relative;
}

.VuePagination {
  display: none;
}

h1,
h2 {
  text-align: center;
}

h1 {
  padding-top: 25px;
  position: relative;
}

h2 {
  color: #636363;
  padding-bottom: 20px;
}

i {
  padding: 5px;
  position: absolute;
  left: 0;
  cursor: pointer;
  border-radius: 50%;
  transition: background-color 0.25s;
}

i:hover {
  background-color: rgba(176, 178, 178, 0.5);
}

.spinner {
  padding-top: 10%;
}

.btn {
  background: var(--primary-color);
  color: white;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.btn:focus {
  box-shadow: none;
}
</style>
